import { LoadingOutlined } from '@ant-design/icons'
import { Spin } from 'antd'
import React, { lazy, Suspense, useEffect, useState } from 'react'
import { Route, BrowserRouter as Router, Routes } from 'react-router-dom'
import './asserts/css/App.css'
import TransitionUtils from './utils/transitionUtils'
import BidGuarantiesList from './components/bidguarantees/BidGuarantiesList'
import BidSecuritiesTable from './components/bidguarantees/BidSecuritiesTable'
import CertifiedCheckList from './components/bidguarantees/CertifiedCheckList'
import DigitalPaymentList from './components/bidguarantees/DigitalPaymentList'
import ViewBidSecurities from './components/bidguarantees/ViewBidSecurities'
import ViewCertifiedCheck from './components/bidguarantees/ViewCertifiedCheck'
import Dashboard from './components/dashboard/Dashboard'
import FinanceDashboard from './components/dashboard/FinanceDashboard'
import InstitutionDashboard from './components/dashboard/InstitutionDashboard'
import CreateInstitutionAccount from './components/institution/CreateInstitutionAccount'
import PrivateRoute from './components/layout/PriviteRoute'
import OTP from './components/login/OTP'
import BidSecurityPaymentReport from './components/payments/BidSecurityPaymentReport'
import ChooseChannel from './components/payments/ChooseChannel'
import PaymentProof from './components/payments/PaymentProof'
import BaillifRefundRequest from './components/refund/BaillifRefundRequest'
import BankTransferUpdateStatus from './components/refund/BankTransferUpdateStatus'
import BiddersEligibleForRefund from './components/refund/BiddersEligibleForRefund'
import BiddersRefundRequest from './components/refund/BiddersRefundRequest'
import BiddersRefundRequestStatus from './components/refund/BiddersRefundRequestStatus'
import EditRefundRequestStatus from './components/refund/EditRefundRequestStatus'
import MakeRefundRequest from './components/refund/MakeRefundRequest'
import PendingBiddersRefundRequest from './components/refund/PendingBidderRefundRequest'
import PendingRefundReminders from './components/refund/PendingRefundReminders'
import RefundRequestList from './components/refund/RefundRequestList'
import RefundRequestReport from './components/refund/RefundRequestReport'
import RequestBidSecurityFees from './components/refund/RequestBidSecurityFees'
import RequestPaymentClaim from './components/refund/RequestPaymentClaim'
import UpdateClaimRefundRequest from './components/refund/UpdateClaimRefundRequest'
import ViewBailiffRefundRequest from './components/refund/ViewBailiffRefundRequest'
import ViewClaimList from './components/refund/ViewClaimList'
import ViewRefundRequest from './components/refund/viewRefundRequest'
import ViewBailiffRefundDashboard from './components/refund/viewBailiffRefundDashboard'
import ViewSuccessRefundsReport from './components/refund/ViewSuccessRefundsReport'
import RefundConfiguration from './components/refund/RefundConfiguration'
// eslint-disable-next-line import/extensions
import AuditLogsDashboard from './components/Audit/AuditLogsDashboard'
import Notification from './components/usersaccounts/Notification'
import UpdateForPublicTreasury from './components/publictreasury/UpdateForPublicTreasury'
import PublicTreasury from './components/publictreasury/PublicTreasury'
import Reports from './components/reporting/Reports'
import BidderNotRequestingBidSecurity from './components/reporting/BidderNotRequestingBidSecurity'
import EditBailiffRefundRequestStatus from './components/refund/EditBailifRefundRequestStatus'
import ViewToPublicTreasuryRequest from './components/publictreasury/ViewToPublicTreasuryRequest'
import SystemAudit from './components/Audit/SystemAudit'
import SystemSupportDashboard from './components/dashboard/SystemSupportDashboard'
import FullDashboard from './components/dashboard/FullDashboard'
import BaillifRequestingBidSecurityFees from './components/refund/bailiffRequestingBidSecurityFees'
// import UserContext from './context/UserContext'
const Login = lazy(async () => await import('../src/components/login/Login'))
const Layout = lazy(async () => await import('../src/components/layout/Layout'))
const Institution = lazy(
  async () => await import('../src/components/institution/CreateInstitution')
)
const ViewInstitution = lazy(
  async () => await import('../src/components/institution/ViewInstitution')
)
const InstitutionTable = lazy(
  async () => await import('../src/components/institution/InstitutionTable')
)
const BidGurantee = lazy(
  async () => await import('../src/components/bidguarantees/CreateBidGuarantee')
)
const BidGuaranteeTable = lazy(
  async () => await import('../src/components/bidguarantees/BidGuaranteeTable')
)
const UsersAccounts = lazy(
  async () => await import('../src/components/usersaccounts/CreateUsersAccounts')
)
const UsersAccountsTable = lazy(
  async () => await import('../src/components/usersaccounts/UsersAccountsTable')
)
const ViewBidGuarantee = lazy(
  async () => await import('../src/components/bidguarantees/ViewBidGuarantee')
)
const BidderTable = lazy(async () => await import('../src/components/bidders/BidderTable'))
const PaymentsTable = lazy(async () => await import('../src/components/payments/PaymentsTable'))
const ViewPayment = lazy(async () => await import('../src/components/payments/ViewPayment'))
const MakePayment = lazy(async () => await import('../src/components/payments/MakePayment'))
const PaymentReceipt = lazy(async () => await import('../src/components/payments/PaymentReceipt'))

const ViewUserAccount = lazy(
  async () => await import('../src/components/usersaccounts/ViewUserAccounts')
)
const ViewBidder = lazy(async () => await import('../src/components/bidders/ViewBidder'))
const CreateUserProfile = lazy(
  async () => await import('../src/components/userprofile/CreateUserProfile')
)
const Page404 = lazy(async () => await import('../src/components/pages/404'))
const antIcon = <LoadingOutlined style={{ fontSize: 'var(--base-font-size)', color: '#37762F' }} spin />
const App: React.FC = () => {
  const [userData, setUserData]: any = useState({})
  // const userInfo = UserContext.userInfo
  useEffect(() => {
    const userInfo = JSON.parse(localStorage.getItem('userInfo') ?? '{}')
    setUserData(userInfo)
  }, []) // userData

  // Initialize global transitions
  useEffect(() => {
    // Initialize transitions after a short delay to ensure DOM is ready
    const timer = setTimeout(() => {
      TransitionUtils.initializePageTransitions()
    }, 100)

    return () => {
      clearTimeout(timer)
    }
  }, [])

  return (
    <>
      <Router>
        <Suspense
          fallback={
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                minHeight: '100vh',
                width: '100%'
              }}
            >
              <Spin indicator={antIcon} />
            </div>
          }
        >
          <Routes>
            <Route path="/" element={<Login />} />
            <Route path="/verify" element={<OTP />} />
            <Route path="/payment" element={<MakePayment />} />
            <Route
              path="/refund-request/bidSecurityReference/:ref_number"
              element={<MakeRefundRequest />}
            />
            <Route
              path="/refund-request/requestBidSecurityFees/:ref_number"
              element={<RequestBidSecurityFees />}
            />
            <Route
            path="/bailiff-refund-request/bailiffRequestingBidSecurityFees/:ref_number"
            element={<BaillifRequestingBidSecurityFees />}
            />
            <Route
              path="/bailiff/baillif-refund-request/bidSecurityReference/:ref_number"
              element={<BaillifRefundRequest />}
            />
            <Route path="/choose-payment/:mcode/:pcode" element={<ChooseChannel />} />
            <Route path="/receipt/:bill_id" element={<PaymentReceipt />} />
            {/* <Route path="/" element={<Navigate replace to="/misbid-login" />} /> */}
            <Route element={<Layout />}>
              <Route path="/" element={<PrivateRoute />}>
                <Route path="/dashboard" element={<Dashboard />} />
                <Route path="/support-dashboard" element={<SystemSupportDashboard />} />
                <Route path="/super-admin-dashboard" element={<FullDashboard />} />
                <Route path="/dashboard" element={<Dashboard />} />
                <Route path="/institution-dashboard" element={<InstitutionDashboard />} />
                <Route path="/finance-dashboard" element={<FinanceDashboard />} />
                {userData?.role === 'SYSTEM ADMIN'
                  ? (
                  <>
                    <Route path="/bidder-list" element={<BidderTable />} />
                    <Route path="/institutions-list" element={<InstitutionTable />} />
                    <Route path="/create-institution" element={<Institution />} />
                    <Route path="/update-credit-account" element={<CreateInstitutionAccount />} />
                    <Route path="/notification" element={<Notification />} />
                    <Route path="/system-audit" element={<SystemAudit />} />
                    <Route path="/payment_proof" element={<PaymentProof />} />
                    <Route
                      path="/bid-security-payment-Report"
                      element={<BidSecurityPaymentReport />}
                    />
                    <Route path="/refund-request-report" element={<RefundRequestReport />} />
                    <Route path="/view-institution" element={<ViewInstitution />} />
                    <Route path="/create-users-accounts" element={<UsersAccounts />} />
                    <Route path="/payment-list" element={<PaymentsTable />} />
                    <Route path="/bid-guarantee-list" element={<BidGuaranteeTable />} />
                    <Route path="/view-bid-guarantee" element={<ViewBidGuarantee />} />
                    <Route path="/refund-request-list" element={<RefundRequestList />} />
                    <Route path="/pending-refund-reminders" element={<PendingRefundReminders />} />
                    <Route path="/pending-refund-reminders/:reminderSource/:transactionReference" element={<PendingRefundReminders />} />
                    <Route path="/view-refund-request" element={<ViewRefundRequest />} />
                    <Route path="/view-refund-bailiffs" element={<ViewBailiffRefundDashboard />} />
                    <Route path="/success-refunds-report" element={<ViewSuccessRefundsReport />} />
                    <Route path="/refund-configuration" element={<RefundConfiguration />} />
                    <Route path="/audit-logs" element={<AuditLogsDashboard />} />
                    <Route path="/request-payment-claim" element={<RequestPaymentClaim />} />
                    <Route path="/request-payment-claim/bidders" element={<RequestPaymentClaim />} />
                    <Route path="/request-payment-claim/bailiff" element={<RequestPaymentClaim />} />
                    <Route path="/reporting-process" element={<Reports />} />
                    <Route path="/public-treasury" element={<PublicTreasury />} />
                    <Route path="/update-for-public-treasury" element={<UpdateForPublicTreasury />} />
                    <Route
                      path="/update-claim-refund-request"
                      element={<UpdateClaimRefundRequest />}
                    />
                    <Route path="/view-list" element={<ViewClaimList />} />
                    <Route
                      path="/bidder-refund-request-status"
                      element={<BiddersRefundRequestStatus />}
                    />
                  </>
                    )
                  : (
                      ''
                    )}
                {userData?.role === 'INSTITUTION ADMIN' || userData?.role === 'INSTITUTION USER'
                  ? (
                  <>
                    <Route path="/create-bid-guarantee" element={<BidGurantee />} />
                    {userData?.role !== 'INSTITUTION USER'
                      ? (
                      <Route path="/create-users-accounts" element={<UsersAccounts />} />
                        )
                      : (
                          ''
                        )}
                  </>
                    )
                  : (
                      ''
                    )}
                {userData?.role === 'MINIJUST FINANCE'
                  ? (
                  <>
                    <Route path="/payment-list" element={<PaymentsTable />} />
                    <Route path="/bid-guarantee-list" element={<BidGuaranteeTable />} />
                    <Route path="/bid-securities-list" element={<BidSecuritiesTable />} />
                    <Route path="/digital-payments-list" element={<DigitalPaymentList />} />
                    <Route path="/certified-check-list" element={<CertifiedCheckList />} />
                    <Route path="/bid-guaranties-list" element={<BidGuarantiesList />} />
                    <Route path="/bidders-refund-request" element={<BiddersRefundRequest />} />
                    <Route path="/view-refund-request" element={<ViewRefundRequest />} />
                    <Route path="/view-refund-bailiffs" element={<ViewBailiffRefundDashboard />} />
                    <Route path="/success-refunds-report" element={<ViewSuccessRefundsReport />} />
                    <Route path="/refund-configuration" element={<RefundConfiguration />} />
                    <Route path="/audit-logs" element={<AuditLogsDashboard />} />
                    <Route path="/public-treasury" element={<PublicTreasury />} />
                    <Route path="/reporting-process" element={<Reports />} />
                    <Route path="/view-to-public-treasury-request" element={<ViewToPublicTreasuryRequest />} />
                    <Route path="/bidders-not-requesting-bid-security" element={<BidderNotRequestingBidSecurity />} />
                    <Route
                      path="/bidder-refund-request-status"
                      element={<BiddersRefundRequestStatus />}
                    />
                    <Route path="/view-bid-securities" element={<ViewBidSecurities />} />
                    <Route path="/view-bid-guarantees" element={<ViewBidGuarantee />} />
                    <Route
                      path="/bank-transfer-update-status"
                      element={<BankTransferUpdateStatus />}
                    />
                    <Route path="/view-certified-check-details" element={<ViewCertifiedCheck />} />
                    <Route path="/bidder-refund-request" element={<BiddersRefundRequest />} />
                    <Route
                      path="/pending-bidder-refund-request"
                      element={<PendingBiddersRefundRequest />}
                    />
                    <Route path="/pending-refund-reminders" element={<PendingRefundReminders />} />
                    <Route path="/pending-refund-reminders/:reminderSource/:transactionReference" element={<PendingRefundReminders />} />
                    <Route
                      path="/bidders-eligible-for-refund"
                      element={<BiddersEligibleForRefund />}
                    />
                    <Route
                      path="/view-bailiff-refund-request"
                      element={<ViewBailiffRefundRequest />}
                    />
                    <Route
                      path="/edit-refund-request-status"
                      element={<EditRefundRequestStatus />}
                    />
                    <Route path="/request-payment-claim" element={<RequestPaymentClaim />} />
                    <Route path="/request-payment-claim/bidders" element={<RequestPaymentClaim />} />
                    <Route path="/request-payment-claim/bailiff" element={<RequestPaymentClaim />} />
                    <Route path="/update-for-public-treasury" element={<UpdateForPublicTreasury />} />
                    <Route
                      path="/update-claim-refund-request"
                      element={<UpdateClaimRefundRequest />}
                    />
                    <Route
                      path="/edit-bailiff-refund-request-status"
                      element={<EditBailiffRefundRequestStatus />}
                    />
                    <Route path="/view-list" element={<ViewClaimList />} />
                  </>
                    )
                  : (
                      ''
                    )}
                  {userData?.role === 'SYSTEM SUPPORT'
                    ? (
                      <>
                        <Route path="/payment-list" element={<PaymentsTable />} />
                        <Route path="/bidder-list" element={<BidderTable />} />
                        <Route path="/bid-securities-list" element={<BidSecuritiesTable />} />
                        <Route path="/digital-payments-list" element={<DigitalPaymentList />} />
                        <Route path="/institutions-list" element={<InstitutionTable />} />
                        <Route path="/certified-check-list" element={<CertifiedCheckList />} />
                        <Route path="/bid-guarantee-list" element={<BidGuaranteeTable />} />
                        <Route path="/bid-guaranties-list" element={<BidGuarantiesList />} />
                        <Route path="/bidders-refund-request" element={<BiddersRefundRequest />} />
                        <Route path="/view-institution" element={<ViewInstitution />} />
                        <Route path="/refund-request-list" element={<RefundRequestList />} />
                        <Route path="/view-refund-request" element={<ViewRefundRequest />} />
                        <Route path="/view-refund-bailiffs" element={<ViewBailiffRefundDashboard />} />
                        <Route path="/success-refunds-report" element={<ViewSuccessRefundsReport />} />
                        <Route path="/refund-configuration" element={<RefundConfiguration />} />
                        <Route path="/audit-logs" element={<AuditLogsDashboard />} />
                        <Route path="/reporting-process" element={<Reports />} />
                        <Route path="/view-to-public-treasury-request" element={<ViewToPublicTreasuryRequest />} />
                        <Route path="/bidders-not-requesting-bid-security" element={<BidderNotRequestingBidSecurity />} />
                        <Route
                          path="/bidder-refund-request-status"
                          element={<BiddersRefundRequestStatus />}
                        />
                        <Route path="/view-bid-securities" element={<ViewBidSecurities />} />
                        <Route path="/view-bid-guarantee" element={<ViewBidGuarantee />} />
                        <Route
                          path="/bank-transfer-update-status"
                          element={<BankTransferUpdateStatus />}
                        />
                        <Route path="/view-certified-check-details" element={<ViewCertifiedCheck />} />
                        <Route path="/bidder-refund-request" element={<BiddersRefundRequest />} />
                        <Route
                          path="/pending-bidder-refund-request"
                          element={<PendingBiddersRefundRequest />}
                        />
                        <Route path="/pending-refund-reminders" element={<PendingRefundReminders />} />
                        <Route path="/pending-refund-reminders/:reminderSource/:transactionReference" element={<PendingRefundReminders />} />
                        <Route
                          path="/view-bailiff-refund-request"
                          element={<ViewBailiffRefundRequest />}
                        />
                        <Route
                          path="/edit-refund-request-status"
                          element={<EditRefundRequestStatus />}
                        />
                        <Route path="/view-list" element={<ViewClaimList />} />
                      </>
                      )
                    : (
                        ''
                      )}
                {userData?.role === 'SUPER ADMIN'
                  ? (
                    <>
                      <Route path="/payment-list" element={<PaymentsTable />} />
                      <Route path="/bidder-list" element={<BidderTable />} />
                      <Route path="/bid-securities-list" element={<BidSecuritiesTable />} />
                      <Route path="/digital-payments-list" element={<DigitalPaymentList />} />
                      <Route path="/institutions-list" element={<InstitutionTable />} />
                      <Route path="/certified-check-list" element={<CertifiedCheckList />} />
                      <Route path="/bid-guarantee-list" element={<BidGuaranteeTable />} />
                      <Route path="/bid-guaranties-list" element={<BidGuarantiesList />} />
                      <Route path="/bidders-refund-request" element={<BiddersRefundRequest />} />
                      <Route path="/view-institution" element={<ViewInstitution />} />
                      <Route path="/create-institution" element={<Institution />} />
                      <Route path="/refund-request-list" element={<RefundRequestList />} />
                      <Route path="/view-refund-request" element={<ViewRefundRequest />} />
                      <Route path="/view-refund-bailiffs" element={<ViewBailiffRefundDashboard />} />
                      <Route path="/success-refunds-report" element={<ViewSuccessRefundsReport />} />
                      <Route path="/refund-configuration" element={<RefundConfiguration />} />
                      <Route path="/audit-logs" element={<AuditLogsDashboard />} />
                      <Route path="/public-treasury" element={<PublicTreasury />} />
                      <Route path="/view-to-public-treasury-request" element={<ViewToPublicTreasuryRequest />} />
                      <Route path="/bidders-not-requesting-bid-security" element={<BidderNotRequestingBidSecurity />} />
                      <Route
                        path="/bidder-refund-request-status"
                        element={<BiddersRefundRequestStatus />}
                      />
                      <Route path="/reporting-process" element={<Reports />} />
                      <Route path="/view-bid-securities" element={<ViewBidSecurities />} />
                      <Route path="/view-bid-guarantee" element={<ViewBidGuarantee />} />
                      <Route
                        path="/bank-transfer-update-status"
                        element={<BankTransferUpdateStatus />}
                      />
                      <Route path="/view-certified-check-details" element={<ViewCertifiedCheck />} />
                      <Route path="/bidder-refund-request" element={<BiddersRefundRequest />} />
                      <Route
                        path="/pending-bidder-refund-request"
                        element={<PendingBiddersRefundRequest />}
                      />
                      <Route path="/pending-refund-reminders" element={<PendingRefundReminders />} />
                      <Route path="/pending-refund-reminders/:reminderSource/:transactionReference" element={<PendingRefundReminders />} />
                      <Route path="/bidders-not-requesting-bid-security" element={<BidderNotRequestingBidSecurity />} />
                      <Route
                        path="/view-bailiff-refund-request"
                        element={<ViewBailiffRefundRequest />}
                      />
                      <Route path="/request-payment-claim" element={<RequestPaymentClaim />} />
                    <Route path="/request-payment-claim/bidders" element={<RequestPaymentClaim />} />
                    <Route path="/request-payment-claim/bailiff" element={<RequestPaymentClaim />} />
                      <Route path="/update-for-public-treasury" element={<UpdateForPublicTreasury />} />
                      <Route
                        path="/update-claim-refund-request"
                        element={<UpdateClaimRefundRequest />}
                      />
                      <Route
                        path="/bidders-eligible-for-refund"
                        element={<BiddersEligibleForRefund />}
                      />
                      <Route
                        path="/edit-bailiff-refund-request-status"
                        element={<EditBailiffRefundRequestStatus />}
                      />
                      <Route
                        path="/edit-refund-request-status"
                        element={<EditRefundRequestStatus />}
                      />
                      <Route path="/view-list" element={<ViewClaimList />} />
                    </>
                    )
                  : (
                      ''
                    )}
                <Route path="/users-accounts-list" element={<UsersAccountsTable />} />
                <Route path="/view-payment" element={<ViewPayment />} />
                <Route path="/view-user-account" element={<ViewUserAccount />} />
                <Route path="/view-bidder" element={<ViewBidder />} />
                <Route path="/user-profile" element={<CreateUserProfile />} />
                <Route path="*" element={<Page404 />} />
              </Route>
            </Route>
            </Routes>
        </Suspense>
      </Router>
    </>
  )
}

export default App
